<template>
  <v-dialog v-model="value" persistent max-width="600px" v-if="model !== null">
    <ValidationObserver v-slot="{ invalid }" slim>
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("projects.new.title") }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <ValidationProvider v-slot="{ errors }" rules="required" slim>
                <v-text-field
                  v-model="model.project_name"
                  :label="$t('projects.new.proyectNameLabel')"
                  :error-messages="errors"
                  required
                ></v-text-field>
              </ValidationProvider>
            </v-row>
            <v-row>
              <ValidationProvider v-slot="{ errors }" rules="required" slim>
                <v-textarea
                  v-model="model.details"
                  :label="$t('projects.new.description')"
                  :error-messages="errors"
                  required
                ></v-textarea>
              </ValidationProvider>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('input', false)"
            :disabled="loading"
          >
            {{ $t("button.cancel") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="onClickDialogSave"
            :loading="loading"
            :disabled="invalid"
          >
            {{ $t("button.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { CREATE_PROJECT } from "@/store/modules/project";

export default {
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      model: null
    };
  },
  ...mapState({
    keycloak: state => state.authentication.keycloak
  }),
  methods: {
    async onClickDialogSave() {
      this.loading = true;
      await this.$store.dispatch(CREATE_PROJECT, this.model);
      this.$notify({
        type: "success",
        text: "Action completed"
      });
      this.resetDialog();
      // reload site to get new keycloak token with project id of the new project inside attributes
      location.reload();
    },
    resetDialog() {
      this.loading = false;
      this.model = { project_name: "", details: "" };
      this.$emit("input", false);
    }
  },
  mounted() {
    this.resetDialog();
  }
};
</script>

<style scoped></style>
